module.exports = __webpack_public_path__ + "img/35-armenian.5de7fc10.svg";